<div *ngIf="contentVisible"
     class="next-aztec-scanner-notification">
  <div class="next-aztec-scanner-notification__title">
    {{ title | translate }}
  </div>

  <div *ngIf="subtitleVisible"
       class="next-aztec-scanner-notification__subtitle">
    {{ subtitle | translate }}
  </div>

  <div class="next-aztec-scanner-notification__icon">
    <img [src]="icon"
         alt="">
  </div>

  <div class="next-aztec-scanner-notification__button">
    <button class="btn"
            (click)="onClick()">
      {{ buttonLabel | translate }}
    </button>
  </div>
</div>
